import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const ProgressBar = function ProgressBar(props) {
    const { max, current } = props;

    return (
        <div className={styles['progress-bar']}>
            <progress className="progress" max={max} value={current} />
        </div>
    );
};

ProgressBar.propTypes = {
    max: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
};

ProgressBar.defaultProps = {
};

export default ProgressBar;
